module.exports = __webpack_public_path__ + "img/pzbz.e48f0d49.png";